<script setup lang="ts">

interface FaqItem {
  title: string
  description: string
}

const props = defineProps<{
  items?: FaqItem[]
}>()

const expandedStates = ref<boolean[]>(props.items ? props.items.map(() => false) : [])
</script>
<template>
  <div class="bg-gray">
    <div class="container py-18 lg:py-20 text-darkBlue">
      <div class="lg:flex">

        <div class="text-36 lg:text-60 leading-tight lg:w-[351px]">
          {{ $t('faq_title') }}
        </div>

        <div class="flex flex-col gap-y-[50px] lg:gap-y-20 w-full mt-10 lg:mt-0">
          <div v-for="(item, index) in items" :key="index">
            <div class="flex items-start">

              <div class="lg:ml-[90px] xl:ml-[128px] mr-4 lg:mr-12 xl:mr-20">
                <div class="text-18 lg:text-[24px] leading-tight">
                  <button @click="expandedStates[index] = true" class="text-start" :class="{'cursor-text select-text' : expandedStates[index]}">
                    {{ item.title }}?
                  </button>
                </div>
                <transition
                  enter-active-class="transition ease-out duration-300 transform"
                  enter-from-class="opacity-0 scale-y-0"
                  enter-to-class="opacity-100 scale-y-100"
                  leave-active-class="transition ease-in duration-300 transform"
                  leave-from-class="opacity-100 scale-y-100"
                  leave-to-class="opacity-0 scale-y-0"
                >
                    <div v-if="expandedStates[index]" class="font-branding mt-6 text-lightBlack" v-html="item.description">
                    </div>
                </transition>
              </div>

              <button @click="expandedStates[index] = !expandedStates[index]" class="ml-auto">
                <IconArrowUpCircle v-if="expandedStates[index]" class="size-7 lg:size-12" />
                <IconArrowDownCircle v-else class="size-7 lg:size-12" />
              </button>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
